import { registerBlockType } from '@wordpress/blocks';

import edit from './inc/edit';
import save from './inc/save';

registerBlockType('vortex-blocks/card-item', {
  edit,
  save,
});
